export default __webpack_public_path__ + "static/social-mockup-42f1dc0ead2b78585a1f17d9744033f7.png";